import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    //Should never be set, but is set for validation
    // and failsafe reasons.
    { value: 0, label: 'Unspecified' },
    // The user is a current member of the group.
    { value: 1, label: 'Current' },
    // Means the user was a member of the group, but is no longer.
    { value: 2, label: 'Former' },
    // Means the user is a member of the group, but at some point in the future.
    // This can be used, for example, for pre-enrols moving into being normal students,
    // which will happen on a given date via a task run by the events service (or so it does ideally)
    { value: 3, label: 'Future' },
    // Indicates a person that has requested to join a group, but has not yet been approved
    { value: 4, label: 'Requested' },
    // Indicates a person that had requested to join a group, but was denied entry
    { value: 5, label: 'Rejected' },
  ],
});
